import { createIcon } from '@chakra-ui/react';

export const Document = createIcon({
  displayName: 'Document',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        <path d="M16.2997 2.20999C15.8897 1.79999 15.1797 2.07999 15.1797 2.64999V6.13999C15.1797 7.59999 16.4197 8.80999 17.9297 8.80999C18.8797 8.81999 20.1997 8.81999 21.3297 8.81999C21.8997 8.81999 22.1997 8.14999 21.7997 7.74999C20.3597 6.29999 17.7797 3.68999 16.2997 2.20999Z" fill="#6E6789"/>
        <path d="M21 10.19H18.11C15.74 10.19 13.81 8.26 13.81 5.89V3C13.81 2.45 13.36 2 12.81 2H8.57C5.49 2 3 4 3 7.57V16.43C3 20 5.49 22 8.57 22H16.43C19.51 22 22 20 22 16.43V11.19C22 10.64 21.55 10.19 21 10.19ZM12 17.75H8C7.59 17.75 7.25 17.41 7.25 17C7.25 16.59 7.59 16.25 8 16.25H12C12.41 16.25 12.75 16.59 12.75 17C12.75 17.41 12.41 17.75 12 17.75ZM14 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25H14C14.41 12.25 14.75 12.59 14.75 13C14.75 13.41 14.41 13.75 14 13.75Z" fill="#6E6789"/>
      </svg>
    </>
  ),
});
